export const DISMISS_NOTIFICATION = 'DISMISS_NOTIFICATION';
